import { createFileRoute } from '@tanstack/react-router'
import { GlossaryPage, glossaryHead } from '@/components/glossary-page'

const data = {
  term: 'MTTD (Mean Time To Detect)',
  slug: 'mttd',
  definition: `MTTD measures the average time between a failure occurring and the team becoming aware of it. It is the gap between when something breaks and when someone knows it is broken.

A low MTTD means your monitoring and alerting systems are working well. A high MTTD often means you are learning about outages from customer complaints instead of your own tools. That is a sign your monitoring has gaps.

MTTD is the first phase of any incident. It feeds directly into MTTR — you cannot start repairing something you do not know is broken. Reducing MTTD is often the highest-leverage improvement a team can make.`,
  whyItMatters: `Every minute of undetected downtime is a minute where users are affected and no one is working on a fix. MTTD is often the largest component of total incident duration, especially for teams using slow monitoring intervals.

A 5-minute check interval means your MTTD can never be less than 5 minutes in the worst case, and averages around 2.5 minutes even for instant failures. With 30-second checks, that worst case drops to 30 seconds.`,
  howUptrackHelps: `Uptrack's 30-second check intervals minimize MTTD by design. When a service goes down, the next check detects it within 30 seconds. The alert goes out after 2–5 consecutive failed checks, once several locations confirm the failure.

This is 10x faster than tools that check every 5 minutes, turning what could be minutes of silent downtime into near-instant detection.`,
  formula: 'MTTD = Total Detection Time / Number of Incidents',
  relatedTerms: [
    { name: 'MTTR', href: '/glossary/mttr' },
    { name: 'MTTF', href: '/glossary/mttf' },
    { name: 'Alert Fatigue', href: '/glossary/alert-fatigue' },
    { name: 'Synthetic Monitoring', href: '/glossary/synthetic-monitoring' },
  ],
}

export const Route = createFileRoute('/_site/glossary/mttd')({
  component: () => <GlossaryPage data={data} />,
  head: () => glossaryHead(data),
})
